var SwiperCarouselModule = (function(window,document,undefined){

    'use strict';

    /**
     * Variables
     */
    var settings,
        _swiper,
        defaults = {
        "autoplay": false,
        "autoplaySpeed": 2,
        "speed": 400,
        "dots": true,
        "arrows": true,
        "items_xs": 1,
        "items_s": 2,
        "items_m": 3,
        "items_l": 4,
        "items_xl": 5,
        "isCanvasType": false,
        "afterInit": undefined
    };

    var generate = function ( el, options ) {
        settings = _.extend({}, defaults, options || {} );
        var swiperOptions = {};

        if (settings.arrows) {
            swiperOptions.nextButton = '.swiper-button-next';
            swiperOptions.prevButton = '.swiper-button-prev';
        }

        swiperOptions.slidesPerView = settings.items_xl;
        swiperOptions.spaceBetween = 10;
        swiperOptions.nextBackLoop = true;

        swiperOptions.breakpoints = {
            1106: {
                slidesPerView: parseInt(settings.items_l,10)
            },
            961: {
                slidesPerView: parseInt(settings.items_m,10)
            },
            705: {
                slidesPerView: parseInt(settings.items_s,10)
            },
            481: {
                slidesPerView: parseInt(settings.items_xs,10)
            }
        };

        _swiper = new Swiper(el,swiperOptions);

        $('.j-swiper-button').hover(function(e){
            if(!isMobile.any())
                $(this).toggleClass('hover', e.type==='mouseenter');
        });

        _swiper.on('onSlideChangeStart', function(){
            Imgness.refresh();
        });
    };

    var init = function(options) {
        var $carousels = $(options.selector);
        $carousels.each(function() {
            var $el = $(this);
            var elOptions = $el.data('options');
            if(typeof elOptions == "string"){
                elOptions = $.parseJSON(elOptions);
            }
            var settings = _.extend({}, elOptions, options || {} );
            generate($el.get(0),settings);
        });
    };

    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };

    return {
        init:init
    }

}(window,document));
